<template>
    <div class="videos-wrapper">
        <crud-table :actions="actions" server-pagination :page-count="videos.meta.last_page" :current-page="videos.meta.current_page" :total="videos.meta.total" :per-page="videos.meta.per_page" title="الفيديوهات" :items="videosItemsComputed" :headers="headers" @edit="openEditDialog" @delete="openDeleteDialog" @load="loadMore" @create="createDialog =  true" @search="search" @reset="reset" />

        <action-dialog v-model="createDialog" :as-form-data="true" scrollable max-width="400" action="post" :url="`/videos`" success-msg="تم إضافة الفيديو بنجاح" title="إضافة فيديو جديد" subtitle="املأ بيانات الفيديو الجديد" button-text="إنشاء" :data="{...newVideo, lecture_id: lecture_id}" @reset="resetCreateForm" @sync="addItem">
            <div class="pt-1">
                <v-text-field v-model="newVideo.name" autofocus label="عنوان الفيديو"></v-text-field>
                <v-select v-model="newVideo.type" label="نوع الفيديو" :items="videoTypesItems"></v-select>
                <!-- <v-text-field v-if="newVideo.type === 'mp4'" v-model="newVideo.url" append-icon="mdi-link" label="رابط الفيديو" placeholder="أدخل رابط الفيديو"></v-text-field> -->
                <v-text-field v-model="newVideo.url" append-icon="mdi-link" label="معرف الفيديو (ID)" :placeholder="'مثلاً: ' + (newVideo.type === 'vimeo' ? '406599043' : 'SyT3xUPz48E')" hint="معرف الفيديو (ID) هو رمز موجود في رابط الفيديو" persistent-hint></v-text-field>
            </div>
        </action-dialog>

        <action-dialog v-model="editDialog" action="put" :url="`/videos/${editedItem.id}`" max-width="450" success-msg="تم حفظ التغييرات بنجاح" title="تعديل الفيديو" button-text="حفظ" :data="editedItemForm" @reset="resetEditForm" @sync="syncItem">
            <v-text-field v-model="editedItem.name" autofocus label="عنوان الفيديو"></v-text-field>
            <v-select v-model="editedItem.type" label="نوع الفيديو" :items="videoTypesItems"></v-select>
            <v-text-field v-if="appData.teacher_can_control_vd_url" v-model="editedItem.url" append-icon="mdi-link" label="معرف الفيديو (ID)" placeholder="أدخل معرف الفيديو من الرابط"></v-text-field>
            <v-text-field v-model="editedItem.views_limit" type="number" label="الحد اﻷقصى للمشاهدات" hint="اترك الحقل فارغاً إذا كانت المشاهدات مفتوحة بلا حد" persistent-hint min="1"></v-text-field>
        </action-dialog>

        <action-dialog v-if="appData.teacher_can_delete_videos" v-model="deleteDialog" action="delete" :url="`/videos/${deleteVideo ? deleteVideo.id : ''}`" title="حذف الفيديو" button-text="تأكيد الحذف" button-color="error" @sync="deleteItem(deleteVideo.id)">
            <div v-if="deleteVideo">
                <div class="strong-text--text">
                    هل أنت متأكد من حذف الفيديو <b class="strong-text--text">"{{deleteVideo.name}}"</b> ؟
                </div>
            </div>
        </action-dialog>
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        CrudTable,
    },
    props: {
        videos: {},
        page_url: {},
        lecture_id: {},
    },
    data() {
        return {
            editDialog: false,
            editedItem: {
                id: null,
                name: '',
                type: '',
                url: '',
                views_limit: '',
            },

            createDialog: false,
            newVideo: {
                name: '',
                type: '',
                url: '',
            },

            deleteDialog: false,
            deleteVideo: null,

            videosItems: null,
        }
    },
    computed: {
        headers(){
            let headers = [
                {
                    text: 'عمليات',
                    value: 'actions',
                    align: 'start',
                    sortable: false
                },
                /* {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                }, */
                {
                    text: 'الفيديو',
                    align: 'center',
                    sortable: false,
                    value: 'name',
                    button: 'videoUrl',
                    color: 'link'
                },
                {
                    text: 'نوع الفيديو',
                    align: 'center',
                    sortable: false,
                    value: 'type',
                },
                {
                    text: 'الحد اﻷقصى للمشاهدات',
                    align: 'center',
                    sortable: false,
                    value: 'viewsLimit',
                    num: true,
                },
                {
                    text: 'رابط الفيديو',
                    align: 'center',
                    sortable: false,
                    value: 'videoButtonText',
                    externalLink: 'video_url',
                    color: 'success',
                    hide: !this.appData.teacher_can_control_vd_url,
                },
                {
                    text: 'وقت اﻹنشاء',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ];
            return headers.filter(h=>{
                return !h.hide;
            })
        },
        videosItemsComputed(){
            return this.videosItems.map(video=>{
                return {
                    ...video,
                    videoUrl: '/videos/' + video.id,
                    videoButtonText: 'فتح الفيديو',
                    viewsLimit: video.views_limit ? video.views_limit : 'بدون حد'
                }
            });

        },
        editedItemForm(){
            const editedItem = this.editedItem;
            let form = {name: editedItem.name, type: editedItem.type, views_limit: editedItem.views_limit};
            if (this.appData.teacher_can_control_vd_url){
                form.url = editedItem.url;
            }
            return form;
        },
        actions(){
            let actions = [
                {name: 'edit', text: 'تعديل', icon: 'mdi-pencil'},
            ];

            if (this.appData.teacher_can_delete_videos){
                actions.push({name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'error'});
            }
            return actions;
        },
        videoTypesItems(){
            let types = [{text: 'Vimeo', value: 'vimeo'}];
            if (this.appData.enable_youtube_videos){
                types.push({text: 'Youtube', value: 'youtube'});
            }
            return types;
        },
        ...GlobalComputed,
    },
    watch: {
        videos(videos){
            this.videosItems = videos.data;
        }
    },
    methods: {
        ...GlobalMethods,
        loadMore(payload){
            const page = payload.page;
            this.$emit('loadMore', page);
        },
        addItem(item){
            this.videosItems.push(item);
        },
        resetCreateForm(){
            this.newVideo = {
                name: '',
                type: '',
                url: '',
            };
        },
        search(query){
            this.$inertia.visit(`${this.page_url}?query=${query}`);
        },
        reset(){
            this.$inertia.visit(this.page_url);
        },
        openEditDialog(video){
            Object.assign(this.editedItem, video);
            this.editDialog = true;
        },
        resetEditForm(){
            Object.assign(this.editedItem, {
                id: null,
                name: '',
                type: '',
                url: '',

            });
        },
        syncItem(newItem){
            this.videosItems = this.videosItems.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        deleteItem(id){
            this.videosItems = this.videosItems.filter(item=>{
                return item.id !== id;
            })
        },
        editAction(){

        },
        openDeleteDialog(video){
            this.deleteDialog = true;
            this.deleteVideo = video;
        },

    },
    created(){
        this.videosItems = this.videos.data;
    }
}

</script>
